import { useCallback, useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'

import EmailForm from 'components/EmailForm'
import ErrorDialog from 'components/ErrorDialog'
import { FlexContainer } from 'components/Flex'
import Panel from 'components/Panel'
import useAuth, { getSignUpEmail, isSignInWithEmailLink, signInWithEmailLink } from 'lib/auth'

export default function FinishLoginPage() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const email = getSignUpEmail()
  const [error, setError] = useState(null)
  const history = useHistory()

  const signInWithEmail = useCallback(email => {
    setLoading(true)
    signInWithEmailLink(email, window.location.href).catch(e => {
      if (e.code === 'auth/invalid-email') {
        e.message =
          'ログインに失敗しました。受信したメールアドレスと同じメールアドレスを入力してください'
      } else {
        e.message =
          'ログインに失敗しました。大変お手数おかけしますが、再度ログイン画面からお試しください。'
      }
      setError(e)
      setLoading(false)
    })
  }, [])

  useEffect(() => {
    if (isSignInWithEmailLink(window.location.href) && email) {
      signInWithEmail(email)
    }
  }, [signInWithEmail, email])

  // ログイン成功
  if (user) {
    return <Redirect to="/" />
  }

  return (
    <>
      {Boolean(email) ? (
        <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </FlexContainer>
      ) : (
        <Panel centered>
          <EmailForm loading={loading} onSubmit={signInWithEmail} finishLogin />
        </Panel>
      )}
      {Boolean(error) && (
        <ErrorDialog
          error={error.message}
          onClose={() =>
            error.code === 'auth/invalid-email' ? setError(null) : history.replace('/login')
          }
        />
      )}
    </>
  )
}
